angular.module('bribac.components.subjectOverview', [
  'pascalprecht.translate',
  'bribac.components.collapsingBox',
  'bribac.components.cardTestStatus',
  'bribac.components.testDetails',
  'bribac.services.newMessageEditorModal'
])

    .component('subjectOverview', {
        templateUrl: 'subject-overview-component.html',
        controller: 'SubjectOverviewCtrl',
        bindings: {
            subject: '<',
            collapsed: '<'
        }
    })

  .controller('SubjectOverviewCtrl', function(
    newMessageEditorModal
  ) {
    this.newMessageEditorModal = newMessageEditorModal
  })
